module.exports = __webpack_public_path__ + "static/media/banner-resumo-do-edital.f76c0da5.svg";